import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("evodevi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const TOKEN_KEY = "evodevi_token";
export const USER_KEY = "evodevi_user";
export const ROLE_KEY = "evodevi_role";

export const saveAuth = (token, profile, role) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(profile));
  localStorage.setItem(ROLE_KEY, role || "student");
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(ROLE_KEY);
};

export const getUser = () => {
  try { return JSON.parse(localStorage.getItem(USER_KEY) || "null"); }
  catch { return null; }
};

export const getRole = () => localStorage.getItem(ROLE_KEY) || "student";

export const SUBJECTS = [
  { key: "matematik", name: "Matematik", color: "#0284C7", bg: "#E0F2FE" },
  { key: "turkce", name: "Türkçe", color: "#DB2777", bg: "#FCE7F3" },
  { key: "ingilizce", name: "İngilizce", color: "#CA8A04", bg: "#FEF9C3" },
  { key: "fen", name: "Fen Bilimleri", color: "#16A34A", bg: "#DCFCE7" },
  { key: "sosyal", name: "Sosyal Bilgiler", color: "#EA580C", bg: "#FFEDD5" },
  { key: "almanca", name: "Almanca", color: "#9333EA", bg: "#F3E8FF" },
  { key: "fransizca", name: "Fransızca", color: "#4338CA", bg: "#E0E7FF" },
  { key: "italyanca", name: "İtalyanca", color: "#B91C1C", bg: "#FEE2E2" },
];

export const subjectMeta = (key) => SUBJECTS.find((s) => s.key === key) || { name: key, color: "#1D3557", bg: "#F3F0EB" };

export const errMsg = (err, fallback = "Bir hata oluştu") => {
  const d = err?.response?.data?.detail;
  // Detailed server-provided error takes priority
  if (d) {
    if (typeof d === "string") return d;
    if (Array.isArray(d)) {
      return d.map((x) => (typeof x === "string" ? x : x?.msg || JSON.stringify(x))).join(" · ");
    }
    if (typeof d === "object") return d.msg || JSON.stringify(d);
    return String(d);
  }
  // Server responded with a status but no detail → generic status-based message
  const status = err?.response?.status;
  if (status && status >= 500) return "Sunucu şu an yanıt vermiyor. Birkaç dakika sonra tekrar dene.";
  if (status === 429) return "Çok fazla istek gönderildi. Kısa bir mola verip tekrar dene.";
  if (status === 401) return "Oturum süresi doldu. Lütfen tekrar giriş yap.";
  // Network-level failures (no response at all)
  const msg = err?.message || "";
  if (err?.code === "ECONNABORTED" || /timeout/i.test(msg)) {
    return "İstek zaman aşımına uğradı. İnternet bağlantını kontrol et.";
  }
  if (/network/i.test(msg) || err?.code === "ERR_NETWORK") {
    return "Sunucuya ulaşılamadı. İnternet bağlantını kontrol edip tekrar dene.";
  }
  return msg || fallback;
};
